// src/resources/bookings/components/BookingList.tsx
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  DateField,
  NumberField,
  FunctionField,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import { formatCurrency } from "../../../utils/formatters";
import { BookingFilters } from "./BookingFilters";
import { BookingStatusChip } from "./BookingStatusChip";
import { BookingActionsCompact } from "./BookingActionsCompact";

export const BookingList = () => (
  <List
    filters={<BookingFilters />}
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <Datagrid rowClick="show">
      <TextField source="id" label="Booking ID" />
      <FunctionField
        label="Property"
        render={(record) => (
          <Box>
            <Typography variant="body2" fontWeight="medium">
              {record.property?.name || "N/A"}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              HID: {record.propertyHid || "N/A"}
            </Typography>
          </Box>
        )}
      />
      <FunctionField
        label="Customer"
        render={(record) => (
          <Box>
            <Typography variant="body2" fontWeight="medium">
              {record.user?.name || record.user?.username || "N/A"}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {record.user?.email || record.user?.username || "N/A"}
            </Typography>
          </Box>
        )}
      />
      <DateField source="checkIn" label="Check-in" />
      <DateField source="checkOut" label="Check-out" />
      <NumberField source="guests" label="Guests" />
      <FunctionField
        label="Amounts"
        render={(record) => (
          <Box>
            <Typography variant="body2" fontWeight="medium">
              {formatCurrency(record.amountB2B2C)}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Profit: {formatCurrency(record.ourProfit)}
            </Typography>
          </Box>
        )}
      />
      <BookingStatusChip />
      <DateField source="createdAt" label="Created" showTime />
      <ShowButton />
      <BookingActionsCompact />
    </Datagrid>
  </List>
);
